import { css } from '@linaria/core';
import { Root as ImageRoot } from '../Image/styles';
import { Root as ButtonRoot } from '../Button/styles';
import media from '../primitives/Media';
import { Typo } from '../primitives/Typo';
export const Root = {
    base: css `
		position: relative;

		overflow: hidden;
		display: flex;
		align-items: center;

		box-sizing: border-box;
		width: 100%;
		margin: var(--banner-spacing-padding-base-rem) auto;
		padding: 0;
		border-radius: var(--banner-corner-radius-all);

		background: rgb(var(--banner-color-background));

		> div {
			padding: var(--banner-spacing-padding-base-rem);
			padding-right: calc(0.9rem + 48px);

			.${ButtonRoot.base} {
				margin-top: var(--banner-spacing-gap-base-rem);
			}

			> p {
				margin-top: 0;
			}
		}

		> .${ButtonRoot.base} {
			position: absolute;
			z-index: 1;
			top: calc(var(--banner-spacing-gap-base-rem) / 2);
			right: calc(var(--banner-spacing-gap-base-rem) / 2);

			opacity: 0.75;
		}

		.${Typo.heading02} {
			overflow: visible;

			width: 100%;
			margin-bottom: 0.5rem;
			padding: 0;

			white-space: normal;
		}

		.${Typo.body02}, .${Typo.heading02} {
			margin-top: var(--banner-spacing-gap-base-rem);
		}

		.${ImageRoot.base} {
			transform: translateZ(0);
			padding: 0;
		}

		.${ImageRoot.base}:not(:empty) {
			background: none;
		}

		/* NICHT Zusammenpacken mit andere media max queries. Das führt zum Problem in [MT] */
		${media('max', 'm')} {
			flex-direction: column;
			text-align: center;

			> div {
				box-sizing: border-box;
				padding: var(--banner-spacing-padding-base-rem);
			}
		}

		${media('max', 'm')} {
			.${Typo.heading02} {
				text-align: center;
			}

			div {
				.${ButtonRoot.base} {
					transform: translateX(-50%);
					margin-left: 50%;
				}
			}
		}

		${media('min', 'm')} {
			.${ImageRoot.base} {
				max-width: 488px;
			}

			.${Typo.heading02} {
				margin-top: -0.65rem;
			}
		}
	`,
};
